import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  Optional,
  ViewEncapsulation
} from '@angular/core';

import { RIBBON_TRANSLATIONS, RibbonTranslations } from './ribbon.translations';

@Component({
  selector: 'shrd-uic-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon-shared.component.scss', './ribbon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class RibbonComponent {
  @HostBinding('class.unstick-small-vh')
  @HostBinding('class.sticky-top')
  @Input()
  fixed = true;

  @Input() containerClass = 'container-fluid mb-0';

  @HostBinding('attr.role') role = 'region';
  @HostBinding('attr.aria-label') ariaLabel = this.ribbonTranslations?.ariaLabel;

  @HostBinding('class.shrd-uic-ribbon') readonly hostClass = true;

  constructor(
    @Optional()
    @Inject(RIBBON_TRANSLATIONS)
    private readonly ribbonTranslations: RibbonTranslations
  ) {}
}
